import React from "react";
import styles from './index.less';


function Loading(){
    return(
        <div className={styles.loadingStyle}>
            <i />
            <span>加载中...</span>
        </div>
    )
}

export default React.memo(Loading);